<template>
  <div ref="extraSmall" class="d-block d-lg-none"></div>
</template>

<script>
export default {
  name: 'IsExtraSmall',
  mounted() {
    // Call immediately on mount to check, then set event listener
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.$emit('isExtraSmall', window.getComputedStyle(this.$refs.extraSmall).display === 'block');
    },
  },
};
</script>
